var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17610_28254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8689 7.0693C18.5114 7.24225 19.018 7.74885 19.191 8.39135C19.5123 9.56515 19.5 12.0116 19.5 12.0116C19.5 12.0116 19.4999 14.4457 19.191 15.6195C19.018 16.262 18.5114 16.7686 17.8689 16.9415C16.6952 17.2504 12 17.2504 12 17.2504C12 17.2504 7.3171 17.2504 6.13095 16.9292C5.48845 16.7562 4.98188 16.2496 4.8089 15.6071C4.5 14.4457 4.5 11.9992 4.5 11.9992C4.5 11.9992 4.5 9.56515 4.8089 8.39135C4.98188 7.74885 5.5008 7.2299 6.13095 7.0569C7.30475 6.74805 12 6.74805 12 6.74805C12 6.74805 16.6952 6.74805 17.8689 7.0693ZM14.4094 11.9992L10.5049 14.248V9.7505L14.4094 11.9992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17610_28254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeRounded);
export default __webpack_public_path__ + "static/media/youtube-rounded.0d1742c4653d4cfbd14f8a7fec58c256.svg";
export { ForwardRef as ReactComponent };